<template>
  <DropdownMenuSub v-if="'items' in mergetagItem">
    <DropdownMenuSubTrigger
      textValue=""
      class="flex items-center justify-between gap-3 bg-transparent rounded-md px-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-accent-1 transition duration-300 cursor-default"
      :class="{
        'hover:bg-gray-400 text-gray-100 hover:text-gray-50': !inverse,
        'hover:bg-[color-mix(in_srgb,var(--c-g100)_50%,var(--c-g10))] text-gray-400 hover:text-gray-600 data-[highlighted]:bg-[color-mix(in_srgb,var(--c-g100)_50%,var(--c-g10))] data-[highlighted]:text-gray-700 data-[state=open]:bg-[color-mix(in_srgb,var(--c-g100)_50%,var(--c-g10))] data-[state=open]:text-gray-700':
          inverse,
      }"
    >
      <span class="leading-[30px] font-inter text-xs font-medium">
        {{ mergetagItem.name }}
      </span>
      <div>
        <font-awesome-icon :icon="['fas', 'angle-right']" class="h-[10px]" />
      </div>
    </DropdownMenuSubTrigger>
    <DropdownMenuPortal>
      <DropdownMenuSubContent
        class="z-[9999] outline-none rounded-md p-[5px] max-h-[350px] overflow-y-auto shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),_0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)] will-change-[opacity,transform] data-[side=top]:animate-slideDownAndFade data-[side=right]:animate-slideLeftAndFade data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade"
        :class="{
          'bg-gray-10': inverse,
          'bg-gray-900': !inverse,
        }"
        :side-offset="2"
        :align-offset="-5"
      >
        <RecursiveGroup
          v-for="(item, index) in mergetagItem.items"
          :key="index"
          :mergetag-item="item"
          :inverse="inverse"
          :search-active="searchActive"
          @insert="emitInsert"
        />
      </DropdownMenuSubContent>
    </DropdownMenuPortal>
  </DropdownMenuSub>

  <DropdownMenuItem
    v-else
    textValue=""
    @select="emitInsert(mergetagItem)"
    class="tiptap-mt-drop-item rounded-md px-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-accent-1 transition duration-300 cursor-pointer"
    :class="{
      'hover:bg-gray-400 text-gray-100 hover:text-gray-50': !inverse,
      'hover:bg-[color-mix(in_srgb,var(--c-g100)_50%,var(--c-g10))] text-gray-400 hover:text-gray-600 data-[highlighted]:bg-[color-mix(in_srgb,var(--c-g100)_50%,var(--c-g10))] data-[highlighted]:text-gray-700':
        inverse,
    }"
  >
    <span class="leading-[30px] font-inter text-xs font-medium">
      <template v-if="searchActive && mergetagItem.parentPath">
        {{ mergetagItem.parentPath }} &gt; {{ mergetagItem.text }}
      </template>
      <template v-else>
        {{ mergetagItem.text }}
      </template>
    </span>
  </DropdownMenuItem>
</template>

<script setup lang="ts">
import { IMergeTagGroup, IMergeTag } from "../../../types/MergeTags";
import {
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuPortal,
  DropdownMenuSubContent,
} from "reka-ui";

defineProps<{
  mergetagItem: IMergeTag | IMergeTagGroup;
  inverse?: boolean;
  searchActive?: boolean;
}>();
const emit = defineEmits<{
  (e: "insert", item: IMergeTag): void;
}>();

const emitInsert = (item: IMergeTag) => {
  emit("insert", item);
};
</script>
